<template>
  <div class="login-dialog-page">
    <el-dialog :visible.sync="isLogin" :closeOnClickModal="false" :showClose="false"
               :destroyOnClose="true" :appendToBody="true" :customClass="'register-page-dialog'" :top="'22vh'">
      <el-form :model="userInfo" :size="'small'" label-width="110px" :rules="newUserInfoRules" ref="userInfo" :inlineMessage="true">
        <div class="title">
          <span>登录</span>
          <span v-if="!codeForLogin" class="login-type" @click="changeLoginType(true)">使用验证码登录</span>
          <span v-else class="login-type" @click="changeLoginType(false)">用户名密码登录</span>
        </div>
        <el-form-item label="角色" prop="roleNum">
          <el-radio-group v-model="userInfo.roleNum">
            <el-radio :label="'ROLE0002'">求职者</el-radio>
            <el-radio :label="'ROLE0001'">招聘者</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户名" prop="userName" v-if="!codeForLogin">
          <el-input v-model="userInfo.userName" prefix-icon="el-icon-user" placeholder="输入用户名" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="passWord" v-if="!codeForLogin">
          <el-input v-model="userInfo.passWord" prefix-icon="el-icon-key" placeholder="输入密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="手机号或邮箱" prop="phone_email" v-if="codeForLogin">
          <el-input v-model="userInfo.phone_email" prefix-icon="el-icon-user" placeholder="手机号或邮箱" clearable></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="loginVerificationCode" v-if="codeForLogin">
          <el-input ref="loginVerificationCode" v-model="userInfo.loginVerificationCode" class="login-verification-code"
                    prefix-icon="el-icon-message" placeholder="输入验证码">
            <el-button v-if="verificationCodeFlag" slot="append" @click="checkPhoneNumberAddSendMsg">发送验证码</el-button>
            <div v-else slot="append" class="login-waiting-code">已发送 {{waitingCodeTime}} s</div>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()" size="small">取 消</el-button>
        <el-button type="primary" @click="submit('userInfo')" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'LoginDialog',
  props: ['isLogin'],
  data () {
    // 手机号或邮箱校验
    let validatePhoneOrEmail = (rule, value, callback) => {
      if (!(/^1[3456789]\d{9}$/.test(this.userInfo.phone_email.trim())) &&
        !(new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$').test(this.userInfo.phone_email))) {
        callback(new Error('请输入正确的手机号码或邮箱'))
      }
      callback()
    }
    // 验证码校验
    let validateVerificationCode = (rule, value, callback) => {
      if (!(/^\d{6}$/.test(this.userInfo.loginVerificationCode.trim()))) {
        callback(new Error('请输入6位正确的验证码'))
      }
      callback()
    }
    // 用户名校验 /^[\u4E00-\u9FA5\uF900-\uFA2D|\w]{2,20}$/ 中文，英文字母，数字及下划线组成，长度2-20位
    let validateUserName = (rule, value, callback) => {
      if (!(/^[a-zA-Z0-9_-]{4,20}$/.test(this.userInfo.userName.trim()))) {
        callback(new Error('用户名由中文，英文字母，数字及下划线组成，长度2-20位'))
      }
      callback()
    }
    // 密码正则校验
    let validatePass = (rule, value, callback) => {
      if (!(new RegExp('^(?![A-Za-z]+$)(?![A-Z\\d]+$)(?![A-Z\\W]+$)(?![a-z\\d]+$)(?![a-z\\W]+$)(?![\\d\\W]+$)^[a-zA-Z0-9!#*_]{8,20}$').test(this.userInfo.passWord.trim()))) {
        callback(new Error('请输入8-20位大、小写字母、数字或特殊字符(!#*_)，必须至少包含其中三种类型'))
      }
      callback()
    }
    return {
      codeForLogin: false,
      verificationCodeFlag: true,
      userInfo: {
        roleNum: 'ROLE0002',
        phone_email: '',
        loginVerificationCode: '',
        userName: '',
        passWord: ''
      },
      newUserInfoRules: {
        phone_email: [
          {required: true, message: '请输入手机号或邮箱', trigger: 'blur'},
          {validator: validatePhoneOrEmail, trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {validator: validateUserName, trigger: 'blur'}
        ],
        passWord: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'}
        ],
        loginVerificationCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {validator: validateVerificationCode, trigger: 'blur'}
        ]
      },
      waitingCodeTime: 60
    }
  },
  methods: {
    cancel () {
      this.$emit('closeRegisterDialog')
    },
    submit (formName) {
      // todo: 调接口登录; 登录成功存取用户信息，浏览器存会话cookie，设置过期时间
      let params = this.codeForLogin ? {
        number: this.userInfo.phone_email,
        code: this.userInfo.loginVerificationCode
      } : {
        userName: this.userInfo.userName,
        password: this.userInfo.passWord
      }
      this.$http.post(this.$api.loginUser.url, params).then(res => {
        if (res && res.code === 200) {
          this.$cookies.set('user_session', res.data['entryCode'], '15d')
          this.$store.set('Authorization', res.data['entryCode'])
          this.$store.session.set('Authorization', res.data['entryCode'])
          this.$store.set('user', res.data)
          this.$store.session.set('user', res.data)
          this.$emit('closeRegisterDialog', 'loginSuccess')
        }
      })
    },
    checkPhoneNumberAddSendMsg () {
      // 表单只校验一项
      this.$refs['userInfo'].validateField('phone_email', (errMsg) => {
        if (!errMsg) {
          this.verificationCodeFlag = false
          this.$refs.loginVerificationCode.focus()
          let timer = setInterval(() => {
            this.waitingCodeTime--
            if (this.waitingCodeTime === 0) {
              this.waitingCodeTime = 60
              clearInterval(timer)
              this.verificationCodeFlag = true
            }
          }, 1000)
          // 调接口发送验证码
          this.$http.get(this.$api.getVerificationCode.url, {
            number: this.userInfo.phone_email
          }).then(res => {
            console.log(res)
            console.log('前台需要校验验证码么？')
          })
        } else {
          this.$refs.phone_email.focus()
        }
      })
    },
    changeLoginType (flag) {
      this.$refs['userInfo'].resetFields()
      this.codeForLogin = flag
    }
  }
}
</script>

<style>
.login-dialog-page {
  width: 400px;
  height: 260px;
}
  .login-type {
    font-size: 12px;
    cursor: pointer;
    color: #3a8ee6;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginDialog.vue